import styled from 'styled-components';

export const OpenLife = styled.p`
  color: #689ef8;
  cursor: pointer;
`;

export const ContainerButton = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  button {
    margin-right: 10px;
  }
`;

export const ContainerTable = styled.div`
  width: 100%;
  margin: auto;

  .ant-table-row,
  ant-table-row-level-0 {
    td {
      padding: 11px 5px;
      max-width: 400px;
    }
    p {
      margin-bottom: 0;
    }
  }

  .ant-table-thead {
    th {
      padding: 10px;
      background-color: var(--primary-color-sefaz);
      font-weight: 500;
      color: var(--bottom-color-sefaz);
    }
  }
`;
